import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-poll gfu-box gfu-box--flat" }
const _hoisted_2 = {
  class: "gfu-poll__title gfu-hd gfu-hd-h3",
  "data-qa": "project-update-poll:Title"
}
const _hoisted_3 = {
  key: 0,
  class: "gfu-media _mt-3"
}
const _hoisted_4 = {
  class: "gfu-media__body",
  "data-qa": "project-update-poll:CannotVoteReason"
}
const _hoisted_5 = {
  class: "gfu-box__tags",
  "data-qa": "project-update-poll-badge"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_poll_option = _resolveComponent("poll-option")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.ready)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createBlock(_component_poll_option, _mergeProps({
              key: option.pollOptionID
            }, { ref_for: true }, {...option, ...$options.pollOptionProps}, {
              class: "_mb-2",
              onSelected: $options.onVoted,
              "data-qa": `project-update-poll-option:${option.pollOptionID}`
            }), null, 16 /* FULL_PROPS */, ["onSelected", "data-qa"]))
          }), 128 /* KEYED_FRAGMENT */)),
          ($options.restrictionPollMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_base_icon, {
                  name: "circle-info",
                  class: "_mr-2"
                }),
                _createElementVNode("div", _hoisted_4, _toDisplayString($options.restrictionPollMessage), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_base_badge, {
              theme: $options.label.theme
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.label.text), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["theme"])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createBlock(_component_progress_overlay, {
          key: 1,
          visible: true
        }))
  ]))
}